export default defineNuxtRouteMiddleware((_to, _from) => {
  const { $config } = useNuxtApp()
  if (process.env.TARGET_ENV !== 'prod') {
    console.warn(
      `This page cannot be viewed in production.\nこのページは本番では見ることができません。`
    )
  }

  if (import.meta.client && $config.public.enableFeatureFlag) {
    showError({
      statusCode: 404,
      statusMessage: 'Not found'
    })
  }
})
